export const DESIGNS = {
  NORMAL: 'normal',
  HIGHLIGHTED: 'highlighted'
}

export const ALL_OPTIONS_ID = 'allOptions'
